
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.131","height":"11.129","viewBox":"0 0 11.131 11.129"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#e54126"}},[_c('path',{attrs:{"d":"M.938 11.126a.936.936 0 01-.661-1.6L9.535.268a.936.936 0 111.323 1.323L1.6 10.849a.936.936 0 01-.662.274zm0 0"}}),_c('path',{attrs:{"d":"M10.192 11.129a.927.927 0 01-.661-.274L.273 1.599A.936.936 0 011.596.276l9.258 9.258a.934.934 0 01-.662 1.6zm0 0"}})])])
          )
        }
      }
    